/**
 * Created by JIocb on 20.06.2017.
 */
namespace Factive.Game
{
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import Slot = dragonBones.Slot;

    export class HelpPageView
    {
        private static STYLE_TEXT_123:string = "STYLE_TEXT_123";
        private static STYLE_TEXT_456_BLACK:string = "STYLE_TEXT_456_BLACK";
        private static STYLE_TEXT_456_RED:string = "STYLE_TEXT_456_RED";

        private _dc:DependenciesContainer;
        private _lm:LocalizationManager;
        private _armature:dragonBones.Armature;
        private _page:number;
        private _assetScale: number;


        constructor(armature:dragonBones.Armature, dc:DependenciesContainer, page:number)
        {
            this._armature = armature;
            this._dc = dc;
            this._page = page;
            this._lm = this._dc.get("LocalizationManager");
            this._assetScale = this._dc.get("AssetScale");
            this.build();
        }

        private build():void
        {
            let style:PIXI.TextStyle;

            switch(this._page)
            {
                case 1:
                case 2:
                case 3:
                    style = HelpPageView.getStyleByType(HelpPageView.STYLE_TEXT_123,this._assetScale);
                    this.createPixiText("text_1", style);
                    this.createPixiText("text_2", style);
                    break;
                case 4:
                    style = HelpPageView.getStyleByType(HelpPageView.STYLE_TEXT_456_BLACK,this._assetScale);
                    this.createPixiText("text_1", style);
                    this.createPixiText("text_3", style);

                    style = HelpPageView.getStyleByType(HelpPageView.STYLE_TEXT_456_RED,this._assetScale);
                    this.createPixiText("text_4", style);
                    break;
                case 5:
                case 6:
                    style = HelpPageView.getStyleByType(HelpPageView.STYLE_TEXT_456_BLACK,this._assetScale);
                    this.createPixiText("text_1", style);
                    this.createPixiText("text_11", style);
                    this.createPixiText("text_3", style);
                    this.createPixiText("text_31", style);
                    this.createPixiText("text_5", style);

                    style = HelpPageView.getStyleByType(HelpPageView.STYLE_TEXT_456_RED,this._assetScale);
                    this.createPixiText("text_2", style);
                    this.createPixiText("text_4", style);
                    this.createPixiText("text_6", style);
                    break;
            }
        }

        private static getStyleByType(type:string,assetScale:number):PIXI.TextStyle
        {
            let style:PIXI.TextStyle;

            switch(type)
            {
                case HelpPageView.STYLE_TEXT_123:
                    style = new PIXI.TextStyle({
                        fontFamily:'Medium',
                        fontSize:15 * assetScale,
                        fill:'#000000',
                        align:"center",
                        wordWrap:true,
                        wordWrapWidth:400* assetScale
                    });
                    break;
                case HelpPageView.STYLE_TEXT_456_BLACK:
                    style = new PIXI.TextStyle({
                        fontFamily:'Bold',
                        fontSize:13 * assetScale,
                        fill:'#000000',
                        align:"center",
                        wordWrap:true,
                        wordWrapWidth:400* assetScale
                    });
                    break;
                case HelpPageView.STYLE_TEXT_456_RED:
                    style = new PIXI.TextStyle({
                        fontFamily:'Bold',
                        fontSize:13 * assetScale,
                        fill:'#f9547f',
                        align:"center",
                        wordWrap:true,
                        wordWrapWidth:400* assetScale
                    });
                    break;
            }

            return style;
        }

        private createPixiText(name:string, style:PIXI.TextStyle):void
        {
            let slot:Slot = this._armature.getSlot(name);
            if(slot)
            {
                let textId:string = "help_page_" + this._page + "_" + name;
                let text:string = this._lm.getText(textId);
                let pixiText:PIXI.Text = new PIXI.Text(text, style);
                pixiText.anchor.set(.5, 0);
                slot.display = pixiText;
                slot.display.x += (15 * this._assetScale);
            }
        }

        public destroy():void
        {
            this._dc = null;
            this._lm = null;
            this._armature = null;
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/View/HelpPageView.ts